import { BaseService } from "./BaseService";

export const ElementoService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('elemento/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos elementos:', error);
            return false;
        }
    },
    async store(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('elemento', postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a criação de elementos:', error);
            return false;
        }
    },
    async select(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIGet('elemento/select', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos elementos:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`elemento/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de elementos:', error);
            return false;
        }
    }, 
    async update(id, postData) {
        try {
            postData.append("_method", "PUT");
            return await BaseService.fetchResponseFromAPIPost(`elemento/${id}`, postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a atualização de elementos:', error);
            return false;
        }
    }, 
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('elemento/destroy', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao excluir elementos:', error);
            return false;
        }
    }, 
    async activate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('elemento/activate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao ativar elementos:', error);
            return false;
        }
    }, 
    async deactivate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('elemento/deactivate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao desativar elementos:', error);
            return false;
        }
    }, 
}